<template>
  <van-collapse v-model="activeName" accordion class="legalinstitutions">
    <van-collapse-item
      title="矛盾调度处置中心业务系统"
      name="1"
      class="legalinstitutions-item"
      :class="{ 'legalinstitutions-item-check': activeName == '1' }"
    >
      <div class="info">
        整合区域内全量矛盾纠纷数据，配合推进矛盾纠纷大调解机制做法，构建矛盾调度处置中心。通过<strong>明晰矛盾调解力量，优化协同处置流程，预警重点矛盾事项，分析案件办理效能</strong>，实现对矛盾纠纷相关<strong>事与人的精准评价</strong>等做法，助力政法系统进一步提高大调解机制下的工作效能，并为矛盾调度处置工作科学决策提供有力支撑。
      </div>
      <img
        :src="product_society_society_mddd"
        alt="矛盾调度处置中心业务系统"
        class="legalinstitutions-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.mddd"
          :key="`legalinstitutions-item3-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span
            ><strong>{{ item.item }}</strong
            >{{ item.text }}</span
          >
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="诉源治理"
      name="2"
      class="legalinstitutions-item"
      :class="{ 'legalinstitutions-item-check': activeName == '2' }"
    >
      <div class="info">
        以矛盾“发现-预警-调解-诉讼”为主线，构建诉源治理应用平台。实现源头矛盾归集和风险综合研判、实现调解资源统筹调度、实现诉调一键衔接。对各类矛盾实行分层、多跨、递进式化解，对可能引发重大矛盾的行业、区域、镇村等进行风险评估并发出智能预警，推动矛盾化解更高效、更精准。
      </div>
      <img
        :src="product_society_society_syzl"
        alt="诉源治理"
        class="legalinstitutions-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.syzl"
          :key="`legalinstitutions-item1-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span>{{ item }}</span>
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="信访通"
      name="3"
      class="legalinstitutions-item"
      :class="{ 'legalinstitutions-item-check': activeName == '3' }"
    >
      <div class="info">
        “信访通”手机端是供决策层使用的移动端研判分析系统，依托政务平台作为决策基础数据，借助人工智能技术，对社会发展、环境演变、热点问题、群众需求进行深度分析和洞察，为决策提供高效的数据支撑，从而推动矛盾纠纷源头化解管理体系建设。
      </div>
      <img
        :src="product_society_society_xft"
        alt="信访通"
        class="legalinstitutions-img"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div
          class="superiority-item"
          v-for="(item, index) in advantageList.xft"
          :key="`legalinstitutions-item3-superiority${index + 1}`"
        >
          <img :src="product_society_superiority" alt="重要性标志" />
          <span
            ><strong>{{ item.item }}</strong
            >{{ item.text }}</span
          >
        </div>
      </div>
    </van-collapse-item>
    <van-collapse-item
      title="应急管理"
      name="4"
      class="legalinstitutions-item"
      :class="{ 'legalinstitutions-item-check': activeName == '4' }"
    >
      <div class="info-title">
        “码上安全”智慧监管平台
      </div>
      <div class="info">
        为有效应对经营主体安全意识薄弱、基层安监工作量多，职能监管力量少等基层安全生产监管痛点，着力解决沿街店铺、小微企业“小火亡人”、燃气安全事故多发等难题，专门构建数据/算法应用+物联分析感知+智能决策中枢的一站式智慧监管平台，推动基层安全生产监管由“人防”向“智防”转变，提升政企安全监管智治能力，重塑基层安全治理新模式。
      </div>
      <img
        :src="product_society_society_yjgl1"
        alt="应急管理"
        class="legalinstitutions-img"
        style="margin-bottom: 0;"
      />
      <img
        :src="product_society_society_yjgl2"
        alt="应急管理"
        class="legalinstitutions-img"
        style="margin-top: 8px;"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div class="flex-between">
          <div
            class="superiority-item"
            v-for="(item, index) in advantageList.yjgl"
            :key="`legalinstitutions-item3-superiority${index + 1}`"
            style="width: 40%;white-space: nowrap;"
          >
            <img :src="product_society_superiority" alt="重要性标志" />
            <span
              ><strong>{{ item.item }}</strong
              >{{ item.text }}</span
            >
          </div>
        </div>
      </div>
      <div class="info-title">
        智能应急治理平台
      </div>
      <div class="info">
        2024年2月，国务院办公厅印发《突发事件应急预案管理办法》，着重强调突发事件应急预案体系建设。华院计算依托数字技术及数字化应用，推动基层应急能力建设，构建多元主体贯通协同、全面统筹、平急结合、专长兼备、群防群治、整体智治的基层应急管理体系，打通应急管理“最后一公里”。
      </div>
      <img
        :src="product_society_society_yjgl3"
        alt="应急管理"
        class="legalinstitutions-img"
        style="margin-bottom: 0;"
      />
      <img
        :src="product_society_society_yjgl4"
        alt="应急管理"
        class="legalinstitutions-img"
        style="margin-top: 8px;"
      />
      <div class="superiority">
        <div class="title">产品价值</div>
        <div class="flex-between">
          <div
            class="superiority-item"
            v-for="(item, index) in advantageList.yjgl2"
            :key="`legalinstitutions-item3-superiority${index + 1}`"
            style="width: 40%;white-space: nowrap;"
          >
            <img :src="product_society_superiority" alt="重要性标志" />
            <span
              ><strong>{{ item.item }}</strong
              >{{ item.text }}</span
            >
          </div>
        </div>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import product_society_society_syzl from "@/../static/img/product/product_society_society_syzl.svg";
import product_society_society_xft from "@/../static/img/product/product_society_society_xft.svg";
import product_society_society_mddd from "@/../static/img/product/product_society_society_mddd.png";
import product_society_superiority from "@/../static/img/product/product_society_superiority.png";
import product_society_society_yjgl1 from "@/../static/img/product/product_society_society_yjgl1.svg";
import product_society_society_yjgl2 from "@/../static/img/product/product_society_society_yjgl2.svg";
import product_society_society_yjgl3 from "@/../static/img/product/product_society_society_yjgl3.svg";
import product_society_society_yjgl4 from "@/../static/img/product/product_society_society_yjgl4.svg";

export default {
  data() {
    return {
      product_society_society_syzl,
      product_society_society_xft,
      product_society_society_mddd,
      product_society_superiority,
      product_society_society_yjgl1,
      product_society_society_yjgl2,
      product_society_society_yjgl3,
      product_society_society_yjgl4,
      activeName: "",
      advantageList: {
        syzl: [
          "人/事全维度分析",
          "事的智能研判",
          "重点管控全掌握",
          "态势全局化",
          "一站式业务办理"
        ],
        xft: [
          {
            item: "一个决策分析工具：",
            text:
              "实现属地、事项、专题管理的统计预警，形成信访事件整体管理的预测预警预判机制"
          },
          {
            item: "一套预测预警模型：",
            text:
              "囊括事项数量预测模型，信访人风险预警模型，异常时间节点预警模型，同时探索信访人年龄、着装、行为习惯、地域、等分析模型"
          },
          {
            item: "一套专题分析模版：",
            text:
              "构建数据指标体系和逻辑结构体系，对阶段性重点、热点、难点问题开展专题分析，并建立一套专题分析模版作为持续性输出"
          }
        ],
        mddd: [
          {
            text: "助力护航区域数字驾驶舱落地"
          },
          {
            text: "建成矛盾调度处置中心统一调度工作机制"
          },
          {
            text: "进一步提升当地矛盾大调解机制工作效能"
          }
        ],
        yjgl: [
          {
            text: "智能算法模型"
          },
          {
            text: "AI识别预警"
          },
          {
            text: "动态巡查监测"
          },
          {
            text: "人员操作简易"
          },
          {
            text: "产品轻量部署"
          }
        ],
        yjgl2: [
          {
            text: "物联设备全周期管理"
          },
          {
            text: "风险隐患精准洞察"
          },
          {
            text: "风险分级分类"
          },
          {
            text: "预警信息发布管理"
          },
          {
            text: "基层应急力量建设"
          },
          {
            text: "应急预案匹配"
          },
          {
            text: "智能调度指挥"
          }
        ]
        // syzl: [
        //   "以指数体系为核心，量化考评纠纷化解成效",
        //   "聚焦诉/调全过程，衔接覆盖矛盾生灭全周期",
        //   "深度结合智能算法，推动复杂业务流程提效增质",
        //   "构建预警防范体系，多维分析辅助决策指挥",
        //   "形成评-防-联-治-优的良好局势，推动源头治理责任落实"
        // ]
      }
    };
  }
};
</script>
<style lang="less" scoped>
.legalinstitutions {
  width: 100%;
  /deep/.van-cell {
    height: 94px;
    font-size: 28px;
    color: #08204d;
    line-height: 94px;
    text-align: center;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .legalinstitutions-item {
    padding: 0 64px;
    background: #ffffff;
    .info-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      text-align: left;
      font-style: normal;
      margin-bottom: 18px;
      margin-top: 22px;
    }
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }
  .legalinstitutions-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: blue;
    }
  }
  .legalinstitutions-img {
    width: 100%;
    margin: 44px 0;
  }
  .superiority {
    margin-bottom: 32px;
    .title {
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      margin-bottom: 24px;
      font-weight: 600;
    }
    .flex-between {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .superiority-item {
      display: flex;
      font-size: 24px;
      color: #08204d;
      line-height: 32px;
      margin-bottom: 32px;
      span {
        font-weight: 400 !important;
      }
      img {
        width: 32px;
        height: 32px;
        margin-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product/society/legalinstitutions.vue